import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../api/api";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { ITags } from "../../../types/tags.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditTagForm from "../forms/EditTagsForm/EditTagsForm";
import ViewTagForm from "../forms/EditTagsForm/ViewTagsForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  tag: ITags;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditTagsModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteTag(props.tag.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err: any) {
      console.error(err.message);
      if (
        err.response.data.message ===
        "Cannot delete provider with associated resources."
      ) {
        toast.error(
          "Не можливо видалити постачальника, якщо є повʼязаний з ним ресурс."
        );
      }
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення conditions"
              subTitle="Ви дійсно хочете видалити цей condition? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати condition"
              subTitle='Редагуйте інформацію. Внесіть необхідні зміни та натисніть "Зберегти".'
            ></ModalTitle>
            <EditTagForm
              onApply={onPressApply}
              onClose={() => setIsDelete(true)}
              tag={props.tag}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{props.tag.name}</span>
              </div>
            </div>
            <ViewTagForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              tag={props.tag}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditTagsModal;
